var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "position-relative" },
    [
      _c("div", { staticClass: "row justify-content-center mt-4" }, [
        _c("div", { staticClass: "col-11 text-left search-side" }, [
          _c("div", { staticClass: "right-inner-addon" }, [
            _c("span", [
              _vm.loading
                ? _c("i", [_vm.loading ? _c("inline-loader") : _vm._e()], 1)
                : _c("i", {
                    staticClass: "fa fa-search clickable ignore-popover",
                    attrs: { "aria-hidden": "true" },
                    on: { click: _vm.handleSearchInput },
                  }),
            ]),
            _vm._v(" "),
            _c(
              "form",
              {
                attrs: { autocomplete: "nope", "data-lpignore": "true" },
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                  },
                },
              },
              [
                _c("input", {
                  attrs: {
                    autocomplete: "off",
                    "data-lpignore": "true",
                    type: "hidden",
                  },
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.searchString,
                      expression: "searchString",
                    },
                  ],
                  staticClass: "form-control ignore-popover",
                  attrs: {
                    id: "searchClientInputId",
                    type: "search",
                    placeholder: _vm.$t("global.search.searchForAClient"),
                    autocomplete: "nope",
                    "data-lpignore": "true",
                  },
                  domProps: { value: _vm.searchString },
                  on: {
                    input: [
                      function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.searchString = $event.target.value
                      },
                      _vm.handleSearchInput,
                    ],
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "title text-light-gray mb-2 mb-lg-0",
                    attrs: { for: "searchClientInputId", hidden: "true" },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("global.search.searchForAClient")) +
                        "\n          "
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "popover",
        { ref: "popover", on: { hidden: _vm.handlePopoverHidden } },
        [
          _c(
            "div",
            { attrs: { id: "global-search-card" } },
            _vm._l(_vm.resultSections, function (section) {
              return _c("results-section", {
                key: section,
                attrs: { results: _vm.results[section], type: section },
              })
            }),
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }